import React from "react";
import Card from "../../../Card";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";

export default function CardAdminPermissionGeneral(props) {
    const renderContent = () => (
        <MUIGrid container spacing={2}>
            <MUIGrid item xs={12}>
                <MUITextField
                    value={props.permission ? (props.permission.name ?? "") : ""}
                    autoFocus={true}
                    size="small"
                    label="Name"
                    variant="standard"
                    fullWidth={true}
                    inputProps={{
                        maxLength: 255,
                    }}
                    InputLabelProps={{ shrink: true }}
                    onBlur={(e) => props.onChange({ name: (e.target.value || "").trim() })}
                    onChange={(e) => props.onChange({ name: e.target.value })}
                    required={true}
                    error={props.validationIssues.name ? true : false}
                    helperText={props.validationIssues.name ? props.validationIssues.name : ""}
                />
            </MUIGrid>
            <MUIGrid item xs={12}>
                <MUITextField
                    value={props.permission ? (props.permission.description ?? "") : ""}
                    size="small"
                    label="Description"
                    variant="standard"
                    fullWidth={true}
                    multiline={true}
                    minRows={2}
                    maxRows={6}
                    inputProps={{
                        maxLength: 2000,
                    }}
                    InputLabelProps={{ shrink: true }}
                    onBlur={(e) => props.onChange({ description: (e.target.value || "").trim() })}
                    onChange={(e) => props.onChange({ description: e.target.value })}
                />
            </MUIGrid>
        </MUIGrid>
    );

    return (
        <Card
            renderContent={renderContent}
            getTitle={() => "General"}
        />
    );
}
